import { TEXT_MUTED, BG_MUTED, FONT_TINY } from '../../theme';

// `label` is the canonical/colorMap key (English enum value); `displayLabel`
// is the optional translated text shown to the user.
export default function Badge({ label, colorMap, displayLabel }) {
  const col = (colorMap && colorMap[label]) || { bg: BG_MUTED, text: TEXT_MUTED };
  const visible = (displayLabel !== undefined && displayLabel !== null) ? displayLabel : label;
  return (
    <span style={{
      ...FONT_TINY,
      fontWeight: 600,
      background: col.bg, color: col.text,
      borderRadius: 5, padding: '0.15rem 0.5rem',
      whiteSpace: 'nowrap',
    }}>
      {visible}
    </span>
  );
}
